import React from "react";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import MatchingFieldHighLight from "./MatchingFieldHighLight";
class MatchedColumnUs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedItem: this.props && this.props.searchedItem ? this.props.searchedItem : [],
      showTooltip: false,
    };
  }
  componentDidMount() {
    let tempArr = [];
    if (this.props && this.props.searchedItem && Array.isArray(this.props.searchedItem)) {
      for (let i = 0; i < this.props.searchedItem.length; i++) {
        if (this.props.searchedItem[i] && this.props.searchedItem[i].search) {
          tempArr.push(this.props.searchedItem[i].search);
        }
      }
    } else if (this.props && this.props.searchedItem && this.props.searchedItem.includes("||")) {
      let temp = this.props.searchedItem.split("||");
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].includes("|")) {
          tempArr.push(temp[i].split("|")[0]);
        } else {
          tempArr.push(temp[i]);
        }
      }
    } else if (this.props && this.props.searchedItem && this.props.searchedItem.includes("|")) {
      tempArr.push(this.props.searchedItem.split("|")[0]);
    } else if (this.props && this.props.searchedItem) {
      tempArr.push(this.props.searchedItem);
    }
    this.setState({ searchedItem: [...tempArr] });
  }
  render() {
    return (
      <>
        {!!this && !!this.props && !!this.props.rowData && !!this.props.rowData.matched_column && this.props.rowData.matched_column !== "" && !!this.props.rowData && !!this.props.rowData.tempObject ? (
          <>
            <ReactTooltip className="trademo-tooltip-new matching-field-tooltip" id={"id-" + this.props.rowData.s_no + "-"} backgroundColor="#111828" textColor="#FFFFFF" place="right" effect="solid">
              {this.state.showTooltip ? <MatchingFieldHighLight sno={this.props.rowData.s_no} matchedData={this.props.rowData.matched_column} searchedtextcontent={[...this.state.searchedItem]} inflectionWordList={this.props.inflectionWordList} /> : ""}
            </ReactTooltip>
            <div
              className="w-100 m-0"
              data-tip
              data-for={"id-" + this.props.rowData.s_no + "-"}
              onMouseEnter={() =>
                this.setState({
                  showTooltip: true,
                })
              }
              onMouseLeave={() =>
                this.setState({
                  showTooltip: false,
                })
              }>
              <div>
                {this.props.rowData.matched_column.length > 0 ? (
                  <>
                    <div>
                      {!!this.props.rowData.matched_column && this.props.rowData.matched_column.length
                        ? this.props.rowData.matched_column.map((element, index) => (
                            <span>
                              {element.label}
                              {index !== this.props.rowData.matched_column.length - 1 ? ", " : ""}{" "}
                            </span>
                          ))
                        : ""}
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    );
  }
}
export default withRouter(MatchedColumnUs);
